import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {
    @Input() LoadingMessage="Loading";
  loadingImagePath:string  = '/assets/images/loading.gif';
  constructor() { }

  ngOnInit() {
  }

}
